import { Container } from '@backstage/ui';
import {
  CatalogFilterLayout,
  EntityListProvider,
  EntityOwnerPicker,
  EntityTagPicker,
  UserListFilterKind,
  UserListPicker,
} from '@backstage/plugin-catalog-react';
import {
  EntityListDocsTable,
  TechDocsPicker,
} from '@backstage/plugin-techdocs';
import { EntitySystemPicker } from '../catalog/EntitySystemPicker';

// Mirrors upstream `TechDocsIndexPageContent` (plugin-techdocs/alpha), plus a
// System filter whose options are limited to documented entities.
export const TechDocsIndexPageContent = (props: {
  initialFilter?: UserListFilterKind;
}) => {
  const { initialFilter = 'owned' } = props;
  return (
    <Container mt="6">
      <EntityListProvider>
        <CatalogFilterLayout>
          <CatalogFilterLayout.Filters>
            <TechDocsPicker />
            <UserListPicker initialFilter={initialFilter} />
            <EntityOwnerPicker />
            <EntitySystemPicker filtersForAvailableValues={['techdocs']} />
            <EntityTagPicker />
          </CatalogFilterLayout.Filters>
          <CatalogFilterLayout.Content>
            <EntityListDocsTable />
          </CatalogFilterLayout.Content>
        </CatalogFilterLayout>
      </EntityListProvider>
    </Container>
  );
};
